import { render, staticRenderFns } from "./NotificationFullCreatorApplicationApproved.vue?vue&type=template&id=0d6a6729&scoped=true&"
import script from "./NotificationFullCreatorApplicationApproved.vue?vue&type=script&lang=ts&"
export * from "./NotificationFullCreatorApplicationApproved.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationFullCreatorApplicationApproved.vue?vue&type=style&index=0&id=0d6a6729&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6a6729",
  null
  
)

export default component.exports